import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e5dcdc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-preview-page" }
const _hoisted_2 = { class: "preview-row" }
const _hoisted_3 = { class: "preview-label" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "value-text" }
const _hoisted_7 = { class: "value-text" }
const _hoisted_8 = {
  key: 0,
  class: "price-warning"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-text" }, "※ 実際のお支払い金額と異なる場合があります。", -1))
const _hoisted_10 = [
  _hoisted_9
]

import { get, set, useArrayEvery } from "@vueuse/core";
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
import NumberUtils from "@/clinic/utils/number-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingPreview',
  props: {
    previewAttributes: null
  },
  setup(__props: any) {

const props = __props as {
  previewAttributes: Array;
};

const store = useStore();


const displayAttributes = ref([]);
const showPriceWarning = ref(false);

const setPriceWarning = () => {
  const menu = store.getters["booking/selectedMenu"];
  const displayMenuPrice = menu.displayPrice;
  const options = store.getters["booking/selectedOptions"];
  const displayOptionPrice = useArrayEvery(options, option => option.displayPrice);

  if (displayMenuPrice || (get(options).length > 0 && get(displayOptionPrice))) {
    set(showPriceWarning, true);
  }
};

const previewAttributesContainer = attribute => {
  return {
    staffName: "assignStaffName",
    orderPrice: "assignStaffOrderPrice",
    menuName: "assignMenuName",
    menuOptionName: "assignMenuOptionName",
    totalTime: "assignTotalTime",
    totalPrice: "assignTotalPrice",
  }[attribute];
};

const assignStaffName = () => {
  if (isDefaultStaff) return;

  const staff = store.getters["booking/selectedStaff"];
  if (!staff) return;

  return {
    type: "staffName",
    name: "指名スタッフ",
    value: staff.name_kanji,
  };
};

const assignStaffOrderPrice = () => {
  if (isDefaultStaff) return;

  const staff = store.getters["booking/selectedStaff"];
  if (!staff) return;

  return {
    type: "orderPrice",
    name: "指名料",
    value: NumberUtils.formatJPCurrency(staff.order_price),
  };
};

const assignMenuName = () => {
  const menu = store.getters["booking/selectedMenu"];
  if (!menu) return;

  let currentMenuName = menu.name;
  currentMenuName += " - " + `${menu.time}分`;
  return {
    type: "menuName",
    name: "メニュー・ク&nbsp;ー&nbsp;ポン",
    value: currentMenuName,
  };
};

const assignMenuOptionName = () => {
  const displayOptions = store.getters["booking/selectedOptions"];
  if (!displayOptions || displayOptions.length == 0) return;

  const optionName = displayOptions.map((option: any) => {
    return option.name + " - " + `${option.time}分`;
  });

  return {
    type: "menuOptionName",
    name: "オプション",
    value: optionName,
  };
};

const assignTotalTime = () => {
  const totalMenuTime = computed(() => store.getters["booking/selectedMenu"].time);
  const totalOptionMenuTime = store.getters["booking/totalOptionsTime"];

  return {
    type: "totalTime",
    name: "所要時間（&nbsp;目&nbsp;安&nbsp;）",
    value: `${totalMenuTime.value + totalOptionMenuTime}分`,
  };
};

const assignTotalPrice = () => {
  const menu = store.getters["booking/selectedMenu"];
  const displayMenuPrice = menu.displayPrice;
  if (!displayMenuPrice) return;

  const options = store.getters["booking/selectedOptions"];
  let totalOptionPrice = 0;
  options.forEach(option => {
    if (option.displayPrice) {
      totalOptionPrice += option.price;
    }
  });

  return {
    type: "totalPrice",
    name: "支払い予定金&nbsp;額",
    value: NumberUtils.formatJPCurrency(menu.price + totalOptionPrice),
  };
};

const isDefaultStaff = store.getters["booking/selectUseDefaultStaff"];

onBeforeMount(async () => {
  const attributes = props.previewAttributes
    .map(attribute => {
      return eval(previewAttributesContainer(attribute))();
    })
    .filter(attribute => attribute != null);
  set(displayAttributes, attributes);
  setPriceWarning();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayAttributes.value, (data) => {
      return (_openBlock(), _createElementBlock("div", {
        key: data.name,
        class: "preview-item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: "label-text",
              innerHTML: data.name
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["preview-value", { 'flex-layout': !['menuName', 'menuOptionName'].includes(data.type) }])
          }, [
            (data.type != 'menuOptionName')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(data.value), 1)
                ]))
              : _createCommentVNode("", true),
            (data.type == 'menuOptionName')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "option-item"
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(value), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]))
    }), 128)),
    (showPriceWarning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}
}

})